import * as React from "react";
import { Button, ButtonProps } from "@/components/ui/button";
import { useMagnetic } from "@/hooks/use-magnetic";

interface MagneticButtonProps extends ButtonProps {
  strength?: number;
  radius?: number;
}

const MagneticButton = React.forwardRef<HTMLButtonElement, MagneticButtonProps>(
  ({ strength = 0.35, radius = 120, children, ...props }, forwardedRef) => {
    const magneticRef = useMagnetic<HTMLDivElement>({ strength, radius });

    return (
      <div ref={magneticRef} className="inline-block">
        <Button ref={forwardedRef} {...props}>
          {children}
        </Button>
      </div>
    );
  }
);

MagneticButton.displayName = "MagneticButton";

export { MagneticButton };
